// File: frontend/src/pages/Terms.js
//
// Public Terms of Service page at /terms. No authentication required, for the
// same reason as /privacy: you have to be able to read the agreement before
// you accept it, and a hotspot customer sitting behind a captive portal has no
// account at all.
//
// The CONTENT lives in src/content/termsOfService.js — the single source of
// truth that also generates docs/legal/TERMS_OF_SERVICE.md. The LAYOUT is the
// shared components/legal/LegalDocument.js, the same one /privacy uses.

import React from "react";
import LegalDocument from "../components/legal/LegalDocument";
import {
  TERMS_TITLE,
  TERMS_VERSION,
  TERMS_LAST_UPDATED,
  TERMS_EFFECTIVE_DATE,
  SECTIONS,
} from "../content/termsOfService";

export default function Terms() {
  return (
    <LegalDocument
      metaTitle="Terms of Service | PesaFii"
      metaDescription="The terms on which PesaFii provides hotspot billing and network management: accounts, acceptable use, fees and payouts, liability, termination and dispute resolution."
      title={TERMS_TITLE}
      version={TERMS_VERSION}
      effectiveDate={TERMS_EFFECTIVE_DATE}
      lastUpdated={TERMS_LAST_UPDATED}
      indexAriaLabel="Sections of these terms"
      indexHeading="In these terms"
      sections={SECTIONS}
    />
  );
}
